import { DataGrid } from "components/DataGrid/DataGrid";
import {
  Grid,
  Button,
  Link,
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  Tooltip,
  LinearProgress,
} from "@mui/material";
import { PAGE, PO_ELEMENTS, PO_REASON } from "../common/CONSTANTS";
import { useNavigate } from "react-router-dom";
import React, { useState, useRef, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {
  resetUploadPurchaseOrder,
  uploadManualPoFile,
} from "redux/actions/uploadManualPoAction";
import { encryptString } from "components/common/EncryptDecrypt";
import { showNotificationDialog } from "redux/actions/notificationActions";
import {
  hideNotificationDialogManualPOUpload,
  showNotificationDialogManualPOUpload,
} from "redux/actions/notificationManualPOUploadAction";
import { showErrorMessageByCode } from "services/commonServices";
import { SelectReasonDialog } from "components/common/SelectReasonDialog";
import AlertDialogManualPOUpload from "components/common/AlertDialogManualPOUpload";
import { showNotificationDialogManualOrder } from "redux/actions/notificationManualOrderAction";
export const UploadManualPurchaseOrderError = () => {
  const navigate = useNavigate();
  const gridRef = useRef();
  const [dialog, setDialog] = useState(false);
  const [getNewData, setGetNewData] = useState([]);
  const dispatch = useDispatch();
  const userType = useSelector((state) => state.user);
  const loginResponse = userType.loginResponse;
  const [showFileUploadPopup, setShowFileUploadPopup] = useState(false);
  const [isErrorPopupFlag, setIsErrorPopupFlag] = useState(true);
  const [dialogTitle, setDialogTitle] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const [dialogmessage, setDialogMessage] = useState("");
  const [selectedReasonCode, setSelectedReasonCode] = useState(null);
  const [accessibleButtonlist, setAccessibleButtonlist] = React.useState([]);
  const { accessiblePages } = userType.userType;
  const gridOptions = {
    overlayLoadingTemplate:
      '<span class="custom-loading">No records to display</span>',

    overlayNoRowsTemplate:
      '<span class="custom-no-rows">No records to display</span>',
  };

  const isuploadManualPoResponse = useSelector(
    (state) => state.purchaseOrderUpload.uploadPurchaseOrderResponse
  );
  const isuploadManualPoError = useSelector(
    (state) => state.purchaseOrderUpload.isuploadPurchaseOrderError
  );
  const isuploadManualPoSuccess = useSelector(
    (state) => state.purchaseOrderUpload.isuploadPurchaseOrderSuccess
  );

  useEffect(() => {
    if (accessiblePages) {
      setAccessibleButtonlist(
        accessiblePages[PAGE.UPLOAD_CREATE_MANUAL_ORDER_PO.key]
      );
    }
  }, [accessiblePages]);

  useMemo(() => {
    if (isuploadManualPoResponse) {
      let uploadErrorData = isuploadManualPoResponse?.items?.map(
        (item, index) => ({
          id: index + 1,
          SupplierSiteId: item.SupplierSiteId,
          OldSupplierSiteId: item.SupplierSiteId,
          DestinationLocation: item.DestinationLocation,
          OldDestinationLocation: item.DestinationLocation,
          OrderDate: item.OrderDate,
          OldOrderDate: item.OrderDate,
          DeliveryDate: item.DeliveryDate,
          OldDeliveryDate: item.DeliveryDate,
          PIN: item.PIN,
          OldPIN: item.PIN,
          OrderQtyInCases: item.OrderQtyInCases,
          OrderQtyInPallets: item.OrderQtyInPallets,
          OldOrderQtyInCases: item.OrderQtyInCases,
          OldOrderQtyInPallets: item.OrderQtyInPallets,
          Handball: item.Handball,
          OldHandball: item.Handball,
          Import: item.Import,
          OldImport: item.Import,
          errors: item.errors || [],
        })
      );
      setGetNewData(uploadErrorData);
    }
  }, [isuploadManualPoResponse]);

  useEffect(() => {
    setShowDialog(false);
    if (isuploadManualPoSuccess) {
      setShowFileUploadPopup(false);
    }

    if (isuploadManualPoError && isErrorPopupFlag) {
      setShowFileUploadPopup(false);
      setShowDialog(false);
      const { errTitle, errContent } = showErrorMessageByCode(
        isuploadManualPoResponse
      );
      dispatch(showNotificationDialog(errTitle, errContent, "Done"));
      setShowFileUploadPopup(false);
      setShowDialog(false);
      dispatch(hideNotificationDialogManualPOUpload());
      setIsErrorPopupFlag(false);
      dispatch(resetUploadPurchaseOrder());
    }

    if (
      isuploadManualPoSuccess &&
      isuploadManualPoResponse.status === "success"
    ) {
      setGetNewData([]);
      setDialogTitle("Select Manual Purchase Order Reason");
      setDialogMessage("Please select manual purchase order creation reason");
      setShowDialog(true);
    }
  }, [
    isuploadManualPoSuccess,
    dispatch,
    isErrorPopupFlag,
    isuploadManualPoError,
    isuploadManualPoResponse,
  ]);

  const onConfirmReasonClicked = (reason) => {
    setSelectedReasonCode(reason);
    setShowDialog(false);
    let popupmsg =
      "PO's have been successfully created and are ready for preview.";
    if (
      accessibleButtonlist.includes(
        PO_ELEMENTS.UPLOAD_PO.CONFIRM_WITHOUT_REVIEW
      )
    ) {
      popupmsg =
        popupmsg +
        "If you wish to confirm without reviewing please select 'Confirm' else select 'Review'.";
    }
    dispatch(
      showNotificationDialogManualPOUpload(
        "PO Upload",
        popupmsg,
        "CONFIRM WITHOUT REVIEW",
        "REVIEW",
        "/posummary",
        accessibleButtonlist.includes(
          PO_ELEMENTS.UPLOAD_PO.CONFIRM_WITHOUT_REVIEW
        ),
        accessibleButtonlist.includes(PO_ELEMENTS.UPLOAD_PO.REVIEW_BUTTON)
      )
    );
  };

  const handleUploadConfirm = async () => {
    setShowDialog(false);
    const encryptedEmailId = await encryptString(loginResponse?.email);

    const formData = new FormData();
    formData.append("userId", encryptedEmailId);
    formData.append(
      "requestData",
      JSON.stringify({
        fileName: isuploadManualPoResponse?.fileName,
        jobId: isuploadManualPoResponse?.jobId,
        status: "confirmed",
      })
    );
    formData.append("reasonCode", selectedReasonCode);

    let payload = {
      params: formData,
    };

    dispatch(uploadManualPoFile(payload));
  };

  const handleUploadReview = async () => {
    setShowDialog(false);
    const encryptedEmailId = await encryptString(loginResponse?.email);

    const formData = new FormData();
    formData.append("userId", encryptedEmailId);
    formData.append(
      "requestData",
      JSON.stringify({
        fileName: isuploadManualPoResponse?.fileName,
        jobId: isuploadManualPoResponse?.jobId,
        status: "review",
      })
    );
    formData.append("reasonCode", selectedReasonCode);
    let payload = {
      params: formData,
    };

    dispatch(uploadManualPoFile(payload));
  };
  const onConfirmClick = async () => {
    setShowFileUploadPopup(true);
    const encryptedEmailId = await encryptString(loginResponse?.email);

    const filteredData = getNewData?.map(
      ({
        SupplierSiteId,
        DestinationLocation,
        OrderDate,
        DeliveryDate,
        PIN,
        OrderQtyInCases,
        OrderQtyInPallets,
        Handball,
        Import,
      }) => ({
        SupplierSiteId,
        DestinationLocation,
        OrderDate,
        DeliveryDate,
        PIN,
        OrderQtyInCases,
        OrderQtyInPallets,
        Handball,
        Import,
      })
    );
    const formData = new FormData();
    formData.append("userId", encryptedEmailId);
    formData.append(
      "requestData",
      JSON.stringify({
        items: filteredData,
        fileName: isuploadManualPoResponse?.fileName,
        jobId: isuploadManualPoResponse?.jobId,
        status: "error",
      })
    );

    let payload = {
      params: formData,
    };

    dispatch(uploadManualPoFile(payload));
  };

  const onConfirmClose = () => {
    setDialog(false);
  };

  useEffect(() => {
    if (isuploadManualPoResponse?.fileName) {
      localStorage.setItem(
        "PoRecordsFileForReupload",
        isuploadManualPoResponse.fileName
      );
      localStorage.setItem("jobIdForReupload", isuploadManualPoResponse.jobId);
    }
  }, [isuploadManualPoResponse]);

  const handleDownload = () => {
    const url = isuploadManualPoResponse.fileUrl;
    if (url !== undefined) {
      const fileDownloadTag = document.createElement("a");
      fileDownloadTag.href = url;
      fileDownloadTag.click();
    }
    if (url === undefined) {
      const navigateToUpload = PAGE.UPLOAD_CREATE_MANUAL_ORDER_PO.url;
      dispatch(
        showNotificationDialogManualOrder(
          "Download Error",
          "No records found",
          "Done",
          navigateToUpload
        )
      );
    }
  };

  const UploadPOcolumnDef = [
    {
      headerName: "",
      field: "tooltip",
      width: 55,
      flex: 1,
      cellRenderer: (params) => {
        const error = params.data?.errors?.find(
          (err) => err.field === "DuplicateRecords"
        );

        if (error) {
          return (
            <div className="commonMarginError">
              <div
                style={{
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "center",
                  textAlign: "left",
                }}
              >
                <Tooltip title={error.message}>
                  <IconButton
                    sx={{ color: "red", marginLeft: "auto", padding: "0" }}
                  >
                    <ErrorOutlineIcon sx={{ fontSize: "18px" }} />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          );
        }

        return <div></div>;
      },
    },
    {
      headerName: "Supplier Site ID",
      field: "SupplierSiteId",
      type: "numericColumn",
      headerClass: "center-aligned-header",
      width: 155,
      cellStyle: { textAlign: "left" },
      editable: (params) => {
        return params.data?.errors?.some(
          (err) =>
            err.field === "DuplicateRecords" || err.field === "SupplierSiteId"
        );
      },
      valueSetter: (params) => {
        updateCellValue(params.newValue, "SupplierSiteId", params.data);
        return true;
      },

      cellRenderer: (params) => {
        const error = params.data?.errors?.find(
          (err) => err.field === "SupplierSiteId"
        );
        const duplicateError = params.data?.errors?.find(
          (err) => err.field === "DuplicateRecords"
        );
        const hideError =
          params.data?.SupplierSiteId !== params.data?.OldSupplierSiteId;
        return (
          <div
            style={{
              border:
                (error && !hideError) || (duplicateError && !hideError)
                  ? "1px solid red"
                  : "1px solid #ccc",
            }}
            className="commonMarginError"
          >
            <input
              value={params.value}
              disabled={!duplicateError && !error}
              style={{
                width: "120px",
                textAlign: "left",
                border: "none",
                backgroundColor: "transparent",
              }}
            />
            {error && !hideError && (
              <Tooltip title={error.message}>
                <IconButton sx={{ color: "red", padding: "0" }}>
                  <ErrorOutlineIcon sx={{ fontSize: "18px" }} />
                </IconButton>
              </Tooltip>
            )}
          </div>
        );
      },
    },
    {
      headerName: "Destination Location",
      field: "DestinationLocation",
      type: "numericColumn",
      headerClass: "center-aligned-header",
      width: 85,
      cellStyle: { textAlign: "left" },
      editable: (params) => {
        return params.data?.errors?.some(
          (err) =>
            err.field === "DuplicateRecords" ||
            err.field === "DestinationLocation"
        );
      },
      valueSetter: (params) => {
        updateCellValue(params.newValue, "DestinationLocation", params.data);
        return true;
      },
      cellRenderer: (params) => {
        const error = params.data?.errors?.find(
          (err) => err.field === "DestinationLocation"
        );
        const duplicateError = params.data?.errors?.find(
          (err) => err.field === "DuplicateRecords"
        );
        const hideError =
          params.data?.DestinationLocation !==
          params.data?.OldDestinationLocation;
        return (
          <div
            style={{
              border:
                (error && !hideError) || (duplicateError && !hideError)
                  ? "1px solid red"
                  : "1px solid #ccc",
            }}
            className="commonMarginError"
          >
            <input
              value={params.value}
              disabled={!error && !duplicateError}
              style={{
                width: "70px",
                textAlign: "left",
                border: "none",
                backgroundColor: "transparent",
              }}
            />
            {error && !hideError && (
              <Tooltip title={error.message}>
                <IconButton
                  sx={{
                    color: "red",
                    padding: "0",
                    position: "relative",
                    left: "-20px",
                  }}
                >
                  <ErrorOutlineIcon sx={{ fontSize: "18px" }} />
                </IconButton>
              </Tooltip>
            )}
          </div>
        );
      },
    },

    {
      headerName: "Order Date",
      field: "OrderDate",
      headerClass: "center-aligned-header",
      width: 175,
      editable: (params) => {
        return params.data?.errors?.some((err) => err.field === "OrderDate");
      },
      valueSetter: (params) => {
        updateCellValue(params.newValue, "OrderDate", params.data);
        return true;
      },
      cellRenderer: (params) => {
        const error = params.data?.errors?.find(
          (err) => err.field === "OrderDate"
        );
        const hideError = params.data?.OrderDate !== params.data?.OldOrderDate;
        return (
          <div
            style={{
              display: "flex",
              height: "23px",
              border: error && !hideError ? "1px solid red" : "0",
              borderRadius: "4px",
            }}
            className="labelControl"
          >
            <DatePicker
              value={params.value ? dayjs(params.value, "YYYYMMDD") : null}
              onChange={(date) =>
                updateCellValue(
                  formatDateForBackend(date),
                  "OrderDate",
                  params.data
                )
              }
              disabled={!error}
              format="DD/MM/YYYY"
              disablePast={true}
              sx={{ width: "150px" }}
              size="small"
              slotProps={{
                textField: { 
                  placeholder: "Order Date", 
                  size: "small",
                  inputProps: { 'data-testid': 'order-date-input' }, 
                },
              }}
              className="datePickerStyling"
            />
            {error && !hideError && (
              <Tooltip title={error.message}>
                <IconButton sx={{ color: "red", padding: "0" }}>
                  <ErrorOutlineIcon sx={{ fontSize: "18px" }} />
                </IconButton>
              </Tooltip>
            )}
          </div>
        );
      },
    },

    {
      headerName: "Delivery Date",
      field: "DeliveryDate",
      headerClass: "center-aligned-header",
      width: 175,
      editable: (params) => {
        return params.data?.errors?.some(
          (err) =>
            err.field === "DuplicateRecords" || err.field === "DeliveryDate"
        );
      },
      cellRenderer: (params) => {
        const error = params.data?.errors?.find(
          (err) => err.field === "DeliveryDate"
        );
        const hideError =
          params.data?.DeliveryDate !== params.data?.OldDeliveryDate;

        const duplicateError = params.data?.errors?.find(
          (err) => err.field === "DuplicateRecords"
        );

        return (
          <div
            style={{
              display: "flex",
              border:
                (error && !hideError) || (duplicateError && !hideError)
                  ? "1px solid red"
                  : "0",
              borderRadius: "4px",
              height: "23px",
            }}
            className="labelControl"
          >
            <DatePicker
              value={params.value ? dayjs(params.value, "YYYYMMDD") : null}
              disabled={!error && !duplicateError}
              onChange={(date) =>
                updateCellValue(
                  formatDateForBackend(date),
                  "DeliveryDate",
                  params.data
                )
              }
              format="DD/MM/YYYY"
              className="datePickerStyling"
              disablePast={true}
              sx={{ width: "150px" }}
              size="small"
              slotProps={{
                textField: { 
                  placeholder: "Delivery Date", 
                  size: "small",
                  inputProps: { 'data-testid': 'delivery-date-input' },
                 },
              }}
            />
            {error && !hideError && (
              <Tooltip title={error.message}>
                <IconButton sx={{ color: "red", padding: "0" }}>
                  <ErrorOutlineIcon sx={{ fontSize: "18px" }} />
                </IconButton>
              </Tooltip>
            )}
          </div>
        );
      },
    },

    {
      headerName: "Pin",
      field: "PIN",
      type: "numericColumn",
      headerClass: "center-aligned-header",
      width: 175,
      cellStyle: { textAlign: "left" },
      editable: (params) => {
        return params.data?.errors?.some(
          (err) => err.field === "DuplicateRecords" || err.field === "PIN"
        );
      },

      valueSetter: (params) => {
        updateCellValue(params.newValue, "PIN", params.data);
        return true;
      },
      cellRenderer: (params) => {
        const error = params.data?.errors?.find((err) => err.field === "PIN");
        const hideError = params.data?.PIN !== params.data?.OldPIN;

        const duplicateError = params.data?.errors?.find(
          (err) => err.field === "DuplicateRecords"
        );
        return (
          <div
            style={{
              border:
                (error && !hideError) || (duplicateError && !hideError)
                  ? "1px solid red"
                  : "1px solid #ccc",
            }}
            className="commonMarginError"
          >
            <input
              value={params.value}
              disabled={!error && !duplicateError}
              style={{
                width: "130px",
                textAlign: "left",
                border: "none",
                backgroundColor: "transparent",
              }}
            />
            {error && !hideError && (
              <Tooltip title={error.message}>
                <IconButton sx={{ color: "red", padding: "0" }}>
                  <ErrorOutlineIcon sx={{ fontSize: "18px" }} />
                </IconButton>
              </Tooltip>
            )}
          </div>
        );
      },
    },
    {
      headerName: "Order Quantity (cases)",
      field: "OrderQtyInCases",
      type: "numericColumn",
      minWidth: 120,
      maxWidth: 125,
      headerClass: "centered-header",
      cellStyle: { textAlign: "left" },
      editable: (params) => {
        return params.data?.errors?.some(
          (err) => err.field === "OrderQtyInCases"
        );
      },
      valueSetter: (params) => {
        updateCellValue(params.newValue, "OrderQtyInCases", params.data);
        return true;
      },
      cellRenderer: (params) => {
        const error = params.data?.errors?.find(
          (err) => err.field === "OrderQtyInCases"
        );
        const hideError =
          params.data?.OrderQtyInCases !== params.data?.OldOrderQtyInCases;
        return (
          <div
            style={{
              border: error && !hideError ? "1px solid red" : "1px solid #ccc",
            }}
            className="commonMarginError"
          >
            <input
              value={params.value}
              disabled={!error}
              style={{
                width: "80px",
                textAlign: "left",
                border: "none",
                backgroundColor: "transparent",
              }}
            />
            {error && !hideError && (
              <Tooltip title={error.message}>
                <IconButton sx={{ color: "red", padding: "0" }}>
                  <ErrorOutlineIcon sx={{ fontSize: "18px" }} />
                </IconButton>
              </Tooltip>
            )}
          </div>
        );
      },
    },
    {
      headerName: "Order Quantity (pallets)",
      field: "OrderQtyInPallets",
      type: "numericColumn",
      headerClass: "centered-header",
      minWidth: 120,
      maxWidth: 125,
      cellStyle: { textAlign: "left" },
      editable: (params) => {
        return params.data?.errors?.some(
          (err) => err.field === "OrderQtyInPallets"
        );
      },
      valueSetter: (params) => {
        updateCellValue(params.newValue, "OrderQtyInPallets", params.data);
        return true;
      },
      cellRenderer: (params) => {
        const error = params.data?.errors?.find(
          (err) => err.field === "OrderQtyInPallets"
        );
        const hideError =
          params.data?.OrderQtyInPallets !== params.data?.OldOrderQtyInPallets;
        return (
          <div
            style={{
              border: error && !hideError ? "1px solid red" : "1px solid #ccc",
            }}
            className="commonMarginError"
          >
            <input
              value={params.value}
              disabled={!error}
              style={{
                width: "80px",
                textAlign: "left",
                border: "none",
                backgroundColor: "transparent",
              }}
            />
            {error && !hideError && (
              <Tooltip title={error.message}>
                <IconButton sx={{ color: "red", padding: "0" }}>
                  <ErrorOutlineIcon sx={{ fontSize: "18px" }} />
                </IconButton>
              </Tooltip>
            )}
          </div>
        );
      },
    },
    {
      headerName: "Handball",
      field: "Handball",
      type: "numericColumn",
      headerClass: "center-aligned-header",
      width: 90,
      cellStyle: { textAlign: "left" },
      editable: (params) => {
        return params.data?.errors?.some((err) => err.field === "Handball");
      },
      valueGetter: (params) => (params.data?.Handball ? "Yes" : "No"),
      cellRenderer: (params) => {
        const error = params.data?.errors?.find(
          (err) => err.field === "Handball"
        );
        const hideError = params.data?.Handball !== params.data?.OldHandball;
        return (
          <div
            style={{
              border: error && !hideError ? "1px solid red" : "1px solid #ccc",
            }}
            className="commonMarginError"
          >
            <input
              value={params.value}
              disabled={!error}
              style={{
                width: "90px",
                textAlign: "left",
                border: "none",
                backgroundColor: "transparent",
              }}
            />
            {error && !hideError && (
              <Tooltip title={error.message}>
                <IconButton sx={{ color: "red", padding: "0" }}>
                  <ErrorOutlineIcon sx={{ fontSize: "18px" }} />
                </IconButton>
              </Tooltip>
            )}
          </div>
        );
      },
    },
    {
      headerName: "Import",
      field: "Import",
      type: "numericColumn",
      headerClass: "center-aligned-header",
      width: 90,
      cellStyle: { textAlign: "left" },
      editable: (params) => {
        return params.data?.errors?.some((err) => err.field === "Import");
      },
      valueGetter: (params) => (params.data?.Import ? "Yes" : "No"),
      cellRenderer: (params) => {
        const error = params.data?.errors?.find(
          (err) => err.field === "Import"
        );
        const hideError = params.data?.Import !== params.data?.OldImport;
        return (
          <div
            style={{
              border: error && !hideError ? "1px solid red" : "1px solid #ccc",
            }}
            className="commonMarginError"
          >
            <input
              value={params.value}
              disabled={!error}
              style={{
                width: "90px",
                textAlign: "left",
                border: "none",
                backgroundColor: "transparent",
              }}
            />
            {error && !hideError && (
              <Tooltip title={error.message}>
                <IconButton sx={{ color: "red", padding: "0" }}>
                  <ErrorOutlineIcon sx={{ fontSize: "18px" }} />
                </IconButton>
              </Tooltip>
            )}
          </div>
        );
      },
    },
  ];

  const updateCellValue = (newValue, fieldName, row) => {
    setGetNewData((prevData) =>
      prevData?.map((item) =>
        item.id === row.id
          ? {
              ...item,
              [fieldName]: newValue,
              errors: item.errors,
            }
          : item
      )
    );
  };

  const formatDateForBackend = (dateObject) => {
    return dayjs(dateObject).format("YYYYMMDD");
  };

  return (
    <>
      <AlertDialogManualPOUpload
        onConfirmUpload={handleUploadConfirm}
        isuploadManualPoResponse={isuploadManualPoResponse}
        isuploadManualPoError={isuploadManualPoError}
        onReviewUpload={handleUploadReview}
      />
      <SelectReasonDialog
        reasonType={PO_REASON.ORDER_SUB_TYPE.CREATE}
        title={dialogTitle}
        message={dialogmessage}
        selectReasonDialog={showDialog}
        handleConfirmReason={onConfirmReasonClicked}
      />

      {showFileUploadPopup && !isuploadManualPoSuccess ? (
        <Dialog open={true} maxWidth="sm" fullWidth={true}>
          <DialogTitle>Submitting Orders</DialogTitle>
          <DialogContent>
            <LinearProgress />
            <Typography>
              To ensure the successful submission, please avoid clicking the
              back button, leaving the page, or refreshing it during the
              submission process.
            </Typography>
          </DialogContent>
        </Dialog>
      ) : (
        <div></div>
      )}

      <div className="mainPageStyling">
        <div style={{ display: "flex", alignItems: "center" }}>
          <Typography component="h1" variant="h5" sx={{ mb: 2, mr: 2 }}>
            Validation Failed Manual Purchase Orders Line Items
          </Typography>
        </div>
        <div style={{ width: "100%", height: "calc( 100vh - 210px)" }}>
          <DataGrid
            rowData={getNewData}
            columnDefs={UploadPOcolumnDef}
            className="custom-ag-grid custom-ag-grid-oneline"
            gridOptions={gridOptions}
            getRowClass={(params) => {
              const hasDuplicateError = params.data?.errors?.some(
                (err) => err.field === "DuplicateRecords"
              );
              return hasDuplicateError ? "highlightedRow" : "";
            }}
            defaultColDef={{
              sortable: false,
              filter: false,
              resizable: false,
              wrapHeaderText: true,
              suppressSizeToFit: true,
              autoHeaderHeight: true,
              suppressHorizontalScroll: false,
              headerClass: "header-wrap",
              autoSizeStrategy: { type: "fitCellContents" },
            }}
            gridRef={gridRef}
          />
        </div>

        <Grid
          container
          spacing={2}
          sx={{ marginTop: "10px", marginBottom: "10px" }}
          className="paddingTop0 commonButtons marginBottom0"
        >
          <Grid item xs={12} sm={6} md={6} className="innerPadding">
            <Link
              style={{
                color: "#108810",
                cursor: "pointer",
                fontSize: "11px",
                position: "relative",
                top: "-8px",
              }}
              onClick={handleDownload}
            >
              Download PO Records
            </Link>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            className="innerPadding textAlignButton"
          >
            <Button
              variant="contained"
              color="primary"
              onClick={onConfirmClick}
              style={{ marginRight: "8px" }}
            >
              Confirm
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                localStorage.setItem("triggerUpload", "true");
                navigate(PAGE.UPLOAD_CREATE_MANUAL_ORDER_PO.url);
              }}
            >
              Re-Upload PO
            </Button>
          </Grid>
        </Grid>
        <Dialog open={dialog} onClose={onConfirmClose}>
          <div className="dialogStyling">
            <DialogTitle>PO Confirmation</DialogTitle>
            <DialogContent>
              <DialogContentText>
                PO's have been successfully confirmed
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                className="commonPOButtons"
                variant="contained"
                color="primary"
                onClick={onConfirmClose}
              >
                Close
              </Button>
            </DialogActions>
          </div>
        </Dialog>
      </div>
    </>
  );
};
